export declare type BandwdidthT = { duration: number };
export declare type LatencyT = {
  duration: number;
  get_timeout: number;
  wait_between: number;
  wait_after: number;
  number: number;
  wait_all: boolean;
};

export declare type ConfigT = {
  bandwidth: BandwdidthT;
  latency: LatencyT;
};

//Copied from JS_SDK, just on deps, do not want to bloat speedtest project
export interface ServerConfig {
  bandwidthUrl: string;
  providers: Provider[];
}
export interface Provider {
  id: string;
  speedtestIcmpServer: string;
  speedtestTCPServer: string;
  speedtestUDPServer: string;
  speedtestBlacknutServer: string;
  port: number;
}

export const LOGGING_TAG = "Speedtest";
